export enum TICKET_STATUS {
    HOLD = 'Hold',
    EXPIRED = 'Expired',
    TICKETING = 'Ticketing',
    TICKETED = 'Ticketed'
  }
  export enum PAYMENT_STATUS {
    NOT_PAID = 'Not paid',
    PAID = 'Paid',
  }